import { Component,  Input } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { UserType } from "@shared-features/enums/user-type.enum";
import { ShipmentAction } from "@shared-features/enums/shipment-action.enum";

@Component({
  selector: 'app-gate-to-gate-timeline',
  templateUrl: './gate-to-gate-timeline.component.html',
  styleUrls: ['./gate-to-gate-timeline.component.scss']
})
export class GateToGateTimelineComponent extends BaseComponent {
  @Input() history;
  protected readonly ShipmentAction = ShipmentAction;

  constructor() {
    super();
  }

  public get UserType(): typeof UserType {
    return UserType;
  }
}
